const parseNumberFromApi = (v) => {
    if (v == null || v === "") return null;
    if (typeof v === "number") return Number.isFinite(v) ? v : null;

    const s = String(v).trim();
    if (!s) return null;

    // se vier no formato pt-BR "1.234,56"
    if (s.includes(",")) {
        const n = Number(s.replace(/\./g, "").replace(",", "."));
        return Number.isFinite(n) ? n : null;
    }

    // formato padrão API "1234.56" ou "4.000"
    const n = Number(s);
    return Number.isFinite(n) ? n : null;
};

const normalizeTabValue = (v, fallbackEnabled = true) => {
    // boolean legado
    if (typeof v === "boolean") return { enabled: v };

    // novo padrão
    if (v && typeof v === "object") {
        return { enabled: v.enabled !== false }; // default true
    }

    // ausente => fallback
    return { enabled: fallbackEnabled };
};

const mergeTabsNormalized = (baseTabs = {}, overrideTabs = {}) => {
    const out = {};

    // junta todas as chaves
    const keys = new Set([...Object.keys(baseTabs || {}), ...Object.keys(overrideTabs || {})]);

    for (const k of keys) {
        const baseV = baseTabs?.[k];
        const overV = overrideTabs?.[k];

        // regra: override ganha; se override não existir, cai no base
        if (typeof overV !== "undefined") {
            out[k] = normalizeTabValue(overV, true);
        } else {
            out[k] = normalizeTabValue(baseV, true);
        }
    }

    return out;
};

const patchEndereco = (prefix, e) => ({
    [`${prefix}CEP`]: e?.cep || null,
    [`${prefix}Bairro`]: e?.bairro || null,
    [`${prefix}Logradouro`]: e?.logradouro || null,
    [`${prefix}Numero`]: e?.numero || null,
    [`${prefix}Complemento`]: e?.complemento || null,
    [`${prefix}UfId`]: e?.ufId || null,
    [`${prefix}MunicipioId`]: e?.municipioId || null,
});

const toNumberSafe = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
};

const normalizeFixed = (v, dec = 2) => {
    const n = toNumberSafe(v);
    return Number(n.toFixed(dec));
};

const resolveParceiroVaiEm = (profile, natureza) => {
    const n = (profile?.natureza || natureza || "").toLowerCase();
    // n pode vir "Saida", "Saída", "saida"
    if (n === "saida" || n === "saída") return "destinatario";
    return "remetente"; // default Entrada
};
const resolvePedidoByFuncao = (funcao, fallback) => {
    const f = (funcao || "").toLowerCase();

    // item está no pedido
    if (f === "adicionar" || f === "editar") return true;

    // item fora do pedido
    if (f === "cancelar" || f === "remover") return false;

    return !!fallback;
};
// merge simples de objetos (deep merge) sem perder sub-objetos
const isPlainObject = (v) => v && typeof v === "object" && !Array.isArray(v);
const deepMerge = (base = {}, override = {}) => {
    const out = { ...(base || {}) };

    Object.keys(override || {}).forEach((k) => {
        const bv = out[k];
        const ov = override[k];

        if (isPlainObject(bv) && isPlainObject(ov)) {
            out[k] = deepMerge(bv, ov);
        } else {
            out[k] = ov;
        }
    });

    return out;
};
/**
 * ✅ mergeUiTabs
 * - une abas (cabecalho, itens, financeiro, etc.)
 * - preserva tudo do base e sobrescreve com override
 * - trata labels com merge "esperto"
 */
const mergeUiTabs = (baseUiTabs = {}, overrideUiTabs = {}) => {
    const base = baseUiTabs || {};
    const over = overrideUiTabs || {};

    const merged = deepMerge(base, over);

    // ✅ merge especial de labels em cabecalho (se existir)
    const baseLabels = base?.cabecalho?.labels || {};
    const overLabels = over?.cabecalho?.labels || {};

    if (Object.keys(baseLabels).length || Object.keys(overLabels).length) {
        merged.cabecalho = merged.cabecalho || {};
        merged.cabecalho.labels = {
            ...baseLabels,
            ...overLabels,
        };
    }

    return merged;
};
export {
    parseNumberFromApi,
    normalizeTabValue,
    mergeTabsNormalized,
    patchEndereco,
    resolveParceiroVaiEm,
    normalizeFixed,
    toNumberSafe,
    resolvePedidoByFuncao,
    mergeUiTabs,
};
